import React from 'react';
import { useContent } from '../../../hooks/useContent';
import { conferenceEn } from '../../../content/conferenceEn';
import styles from './ConferenceRegister.module.css';

const ConferenceRegister = () => {
  const { t } = useContent();
  const def = conferenceEn.register;

  const href = t('conferenceRegister.buttonUrl', def.buttonUrl);
  const label = t('conferenceRegister.buttonLabel', def.buttonLabel);

  return (
    <div className={styles.background}>
      <div className={styles.formCard}>
        <h1 className={styles.title}>{t('conference.register.title', def.title)}</h1>

        <p className={styles.infoText}>{t('conferenceRegister.infoText', def.infoText)}</p>

        <a href={href} target="_blank" rel="noopener noreferrer" className={styles.submitButton}>
          {label}
        </a>
      </div>
    </div>
  );
};

export default ConferenceRegister;
